package org.matthewo.api

import kotlinx.serialization.Serializable

/**
 * A device's push subscription, as the browser gives it: where to send notifications, and the keys to encrypt them
 * with, both base64url.
 */
@Serializable
data class PushSubscription(val endpoint: String, val p256dh: String, val auth: String)

/**
 * Which notifications a device gets about the teams it follows, wherever it follows them.
 */
@Serializable
data class PushSettings(
    // when their qualification schedule is posted
    val schedule: Boolean = true,
    // shortly before each of their matches
    val prematch: Boolean = true,
    // when each of their results is posted
    val results: Boolean = true,
)

/**
 * Starts or stops [subscription]'s device being told about [team]'s matches at an event, and changes its [settings]
 * when they're given. With neither, it only asks what the device follows.
 */
@Serializable
data class PushFollow(
    val subscription: PushSubscription,
    val team: Int? = null,
    val follow: Boolean = true,
    val settings: PushSettings? = null,
)

/**
 * The teams a device follows at an event, in order, and which notifications it gets about them.
 */
@Serializable
data class PushFollowing(val teams: List<PushTeam>, val settings: PushSettings)

/**
 * A team a device follows at an event.
 */
@Serializable
data class PushTeam(val number: Int, val name: String?)
